import { BrandIcon } from '~/components/icons/generated/BrandIcon'

type ViewProps = {
  toggleBalloonVisibility: () => void
  isBalloonVisible: boolean
}

export const CoordinateBalloonButtonView: React.FC<ViewProps> = ({
  toggleBalloonVisibility,
  isBalloonVisible,
}) => {
  return (
    <button
      onClick={toggleBalloonVisibility}
      type="button"
      className={`flex size-[30px] items-center justify-center rounded-full bg-white shadow-icon xl:size-[45px] ${
        isBalloonVisible
          ? 'text-black-400/70 opacity-80'
          : 'text-black-400 opacity-85 xl:bg-black/50 xl:text-white xl:opacity-70'
      }`}
    >
      <BrandIcon aria-label="タグを表示する" className="h-4 xl:h-[25px]" />
    </button>
  )
}

type Props = {
  onClick: () => void
  isBalloonVisible: boolean
}

export const CoordinateBalloonButton: React.FC<Props> = ({
  onClick,
  isBalloonVisible,
}) => {
  return (
    <CoordinateBalloonButtonView
      toggleBalloonVisibility={onClick}
      isBalloonVisible={isBalloonVisible}
    />
  )
}
